(function ($) {

    /**
     * Static reference to DOM ELEMENTS
     */
    var DOM = {
        /**
         * Elements capable of performing actions (such as buttons)
         */
        ACTION: {
            SELECT_CREDIT_CARD: '[data-action=select-credit-card]',
            SELECT_EFT: '[data-action=select-instanteft]',
            SELECT_PAYPAL: '[data-action=select-paypal]',
            //SELECT_WALLET: '[data-action=select-wallet]',
            //LOGIN: '#btn-login',
            PAYMENT_METHOD_BTN: '#btn-payment-method'
        },
        /**
         * Elements which capture user entries.
         */
        FIELD: {
            PAYMENT_METHOD: '[data-field=payment-method]',
            PAYMENT_TYPE: '#payment-type',
            AMOUNT_TO_PAY: '#pg-amount-pay',
            AMOUNT_TO_PAY_CHARGE: '#pg-amount-pay-charge',
            AMOUNT_DEPOSIT: '#pg-amount-deposit',
            CARD_NUMBER: '#pg-card-number',
            CARD_CCV: '#pg-ccv',
            CARD_EXPIRATION_DATE: '#pg-expiration',
            TERMS: '[data-field=terms]',
            //USERNAME: '#pg-username',
            //PASSWORD: '#pg-password',
            CARDLIST: '#cardlist',
            USER_ID: '#pg-uid',
            TMT_V2: '#pg-tmtv2',
            PG_RECAPTCH: '#pg-recaptcha-token',
            CARD_STORAGE: '#card-storage'
        },
        /**
         * Elements which are not interactive and only hold text.
         */
        LABEL: {
            CARD_CCV: 'label[for="pg-ccv"]',
            EXTRA_CHARGES: '[data-label=extra-charges]',
            EXTRA_CHARGES_TEXT: '[data-label=extra-charges-text]',
            EXTRA_CHARGES_TOTAL: '[data-label=extra-charges-total]',
            EXTRA_CHARGES_TOTAL_TEXT: '[data-label=extra-charges-total-text]',
            DIGITS: '[data-label=digits-text]',
            CONFIRM_PAYMENT: '[data-label=confirm-payment]',
            CONFIRM_PAYMENT_TEXT: '[data-label=confirm-payment-text]',
            CARD_NUMBER_WARNING_TYPE: '[data-label=card-number-warning-type]',
            CARD_NUMBER_WARNING_INCOMPLETE: '[data-label=card-number-warning-incomplete]',
            CARD_NUMBER_WARNING_ENTRY: '[data-label=card-number-warning-entry]',
            CARD_CVV_WARNING_TEXT: '[data-label=card-cvv-warning-text]',
            EXPIRATION_DATE_FORMAT_TEXT: '[data-label=expiration-date-format-warning]'
        },
        /**
         * Elements which act as containers for other elements.
         */
        CONTAINER: {
            FORM: '#pg-payment-form',
            ERRORS_EXIST: '[data-container=errors-exist]',
            ERROR_DIALOG: '[data-container=error-dialog]',
            CONFIRM_TERMS: '[data-container=confirm-terms]',
            CONFIRM_PAYMENT: '[data-container=confirm-payment]',
            EXTRA_CHARGES: '[data-container=extra-charges]',
            PAGE_INFO: '[data-container=page-info]',
            CREDIT_CARD: '#container_creditcard',
            //WALLET: '#container_wallet',
            PAY: '#container-pay',
            CARDLIST: '#container-cards',
        },
        /**
         * CSS attributes.
         */
        CSS: {
            HIDDEN: 'hidden',
            ERROR: 'error'
        }
    };

    /**
     * Static reference to credit card rejex Strings
     */
    var CARDS = {
        'MASTERCARD': {
            'first': /^(5|2)/,
            'full': /^(5[1-5]|2[2-7])[0-9]{14}$/,
            'mask': '9999-9999-9999-9999'
        },
        'VISA': {
            'first': /^4/,
            'full': /^4[0-9]{12}(?:[0-9]{3})?$/,
            'mask': '9999-9999-9999-9999'
        },
        'AMEX': {
            'first': /^3[47]/,
            'full': /^3[47][0-9]{13}$/,
            'mask': '9999-999999-99999'
        },
        'DINERS': {
            'first': /^3[068]/,
            'full': /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
            'mask': '9999-999999-9999'
        }
    };

    /**
     * Static reference to page info returned from API
     */
    var PAGE_INFO = {};
    var baseUrl = null;

    /**
     * Performs initialization.
     */
    $(function () {
        PAGE_INFO = $.parseJSON($(DOM.CONTAINER.PAGE_INFO).text());
        baseUrl = $(DOM.CONTAINER.PAGE_INFO).data('baseurl');

        initFormValidation();
        $(DOM.FIELD.CARD_EXPIRATION_DATE).inputmask('mm/yy');
        //$(DOM.FIELD.CARD_EXPIRATION_DATE).inputmask('mm/yyyy');
        $(DOM.FIELD.CARD_NUMBER).on('keyup', onCreditCardNumberUpdated);
        $(DOM.FIELD.CARDLIST).on('change', updateExtraChargesWarning);
        $(DOM.FIELD.AMOUNT_TO_PAY).on('keyup', onAmountToPayUpdated);
        $(DOM.FIELD.AMOUNT_DEPOSIT).on('keyup', onAmountToPayUpdated);
        $(DOM.ACTION.SELECT_CREDIT_CARD).on('click', onCreditCardSelected);
        $(DOM.ACTION.SELECT_EFT).on('click', onEftSelected);
        $(DOM.ACTION.SELECT_PAYPAL).on('click', onPayPalSelected);
        //$(DOM.ACTION.SELECT_WALLET).on('click', onWalletSelected);
        //$(DOM.ACTION.LOGIN).on('click', onLoginClicked);
        $(DOM.CONTAINER.FORM).on('submit', function (e) {
            onFormSubmit(e);
        });
        console.log('Window size - width ' + $(window).height());
        console.log('Window size - width ' + $(window).width());
        $('#screen_width').val($( window ).width());
        $('#screen_height').val($( window ).height());
    });

    /**
     * Initializes the jQuery validator with custom rules.
     */
    function initFormValidation() {
        $(DOM.CONTAINER.FORM).validate({
            onkeyup: function (element) {
                $(element).valid();
            }, rules: {
                myField: {
                    lettersonly: true
                }
            }
        });
        var validCardTypes = Object.keys(getValidCards()).join(', ').toLowerCase();
        $.validator.addMethod("validcreditcardType", validateCreditCardType,
            $(DOM.LABEL.CARD_NUMBER_WARNING_TYPE).text().replace(/%t/g, validCardTypes));
        $.validator.addMethod("validcreditcardCompletion", validateCreditCardCompletion,
            $(DOM.LABEL.CARD_NUMBER_WARNING_INCOMPLETE).text().replace(/%t/g, getCardTypeEstimate()));
        $.validator.addMethod("validcreditcardCheckSum", validateCreditCardCheckSum,
            $(DOM.LABEL.CARD_NUMBER_WARNING_ENTRY).text());
        $.validator.addMethod("creditcardexpirationdate", validateCreditCardExpirationDate,
            $(DOM.LABEL.EXPIRATION_DATE_FORMAT_TEXT).text());
        $.validator.addMethod("exactlength", validateExactLength,
            $.validator.format($(DOM.LABEL.CARD_CVV_WARNING_TEXT).text()));
    }

    /**
     * @returns {Array} an list of valid credit card types
     */
    function getValidCards() {
        var result = {};
        for (var cardKey in CARDS) {
            for (var customerFee in PAGE_INFO['customerFees']) {
                if (customerFee.toLowerCase() === cardKey.toLowerCase()) {
                    result[cardKey] = CARDS[cardKey];
                }
            }
        }
        return result;
    }

    /**
     * Checks whether the given String is a begins with a number that corresponds
     * with a recognised card type.
     * @param {String} value the value to be checked.
     * @returns {Boolean} whether or not validation was passed
     */
    function validateCreditCardType(value) {
        value = value.replace(/-/g, '');
        return getCardTypeEstimate() !== undefined;
    }

    /**
     * Checks that the given String is a completed credit card number
     * @param {type} value the value to be checked.
     * @returns {Boolean} whether or not validation was passed
     */
    function validateCreditCardCompletion(value) {
        var found = false;
        value = value.replace(/-/g, '');
        var validCards = getValidCards();
        for (var cardKey in validCards) {
            if (validCards[cardKey].full.test(value)) {
                found = true;
            }
        }
        return found;
    }

    /**
     * Checks that the given String has the correct checksum value
     * @param {type} value the value to be checked.
     * @returns {Boolean} whether or not validation was passed
     */
    function validateCreditCardCheckSum(value) {
        var nCheck = 0, nDigit = 0, bEven = false;
        value = value.replace(/\D/g, "");
        for (var n = value.length - 1; n >= 0; n--) {
            var cDigit = value.charAt(n),
                nDigit = parseInt(cDigit, 10);
            if (bEven) {
                if ((nDigit *= 2) > 9)
                    nDigit -= 9;
            }
            nCheck += nDigit;
            bEven = !bEven;
        }
        return (nCheck % 10) === 0;
    }

    /**
     * Checks whether the given String is a valid credit card expiration date.
     * @param {String} value the value to be checked.
     * @returns {Boolean} whether or not validation was passed
     */
    function validateCreditCardExpirationDate(value) {
        var validDate = /^[0-9]{2}\/[0-9]{2}$/.test(value);
        if (!validDate) {
            validDate = /^[0-9]{2}\/[0-9]{4}$/.test(value);
            if (!validDate) {
                return false;
            } else {
                var temp = value.split('/');
                value = temp[0] + '/' + temp[1].substring(2,4);
                console.log('**new value ' + value);
            }
        }
        var date = value.split('/');
        var month = parseInt(date[0]);
        var year = parseInt(date[1]) + 2000;
        var today = new Date();
        var currentYear = today.getFullYear();
        var currentMonth = today.getMonth() + 1;
        if (year > currentYear) {
            return (year < currentYear + 10) || ((year === (currentYear + 10)) && month < (currentMonth + 1));
        } else if (year === currentYear) {
            return month >= currentMonth;
        } else {
            return false;
        }
    }

    /**
     * Checks whether the given String is a precise length;
     * @param {String} value the value to be checked.
     * @param {type} element the element to be validated.
     * @param {int} param the length that the String should equal to pass validation.
     * @returns {Boolean} whether or not validation was passed
     */
    function validateExactLength(value, element, param) {
        return value.length === param;
    }

    /**
     * Listens to updates on the credit card number text field.
     */
    function onCreditCardNumberUpdated() {
        tryToApplyMask();
        updateCvvLabel();
        updateExtraChargesWarning();
    }

    /**
     * Listens to updates on the amount to pay field.
     */
    function onAmountToPayUpdated() {
        updateExtraChargesWarning();
    }

    /**
     * Attempts to apply an input mast to the credit card number field
     */
    function tryToApplyMask() {
        var cardTypeEstimate = getCardTypeEstimate();
        if (cardTypeEstimate !== undefined) {
            $(DOM.FIELD.CARD_NUMBER).inputmask(cardTypeEstimate.mask);
        } else {
            $(DOM.FIELD.CARD_NUMBER).inputmask('remove');
        }
    }

    /**
     * @returns an estimated credit card type based on the first digit.
     */
    function getCardTypeEstimate() {
        for (var cardKey in getValidCards()) {
            if (CARDS[cardKey].first.test($(DOM.FIELD.CARD_NUMBER).val())) {
                return CARDS[cardKey];
            }
        }
    }

    function getPaymentType() {
        return $(DOM.FIELD.PAYMENT_TYPE).val()
    }

    /**
     * @returns infromation around the currently entered credit card, or undefined
     * if the user hasn't yet entered a valid credit card number.
     */

    function getCurrentCreditCardType() {
        var paymentType = getPaymentType();

        if (paymentType === 'card') {
            for (var cardKey in CARDS) {
                if (CARDS[cardKey].first.test($(DOM.FIELD.CARD_NUMBER).val())) {
                    return cardKey.toLowerCase();
                }
            }
        } else if (paymentType === 'wallet') {
            var card = $(DOM.FIELD.CARDLIST).find('option:selected').data('type');

            if (card !== '') {
                return card;
            }
        }

        return null;
    }


    function getCurrentCreditCard() {
        var cardTypeFound = getCurrentCreditCardType();
        var customerFees = PAGE_INFO['customerFees'];

        if (cardTypeFound !== null) {
            for (var customerFeeKey in customerFees) {
                if (customerFeeKey.toLowerCase() === cardTypeFound.toLowerCase()) {
                    var percentage = customerFees[customerFeeKey] / 100;
                    var originalAmount = parseFloat(getAmount());
                    var customerFee = String(Math.round(originalAmount * (percentage / 100) * 100) / 100);
                    var totalAmount = String(originalAmount + parseFloat(customerFee));
                    return {
                        cardType: cardTypeFound,
                        percentage: percentage,
                        customerFee: convertToMoneyString(customerFee),
                        totalAmount: convertToMoneyString(totalAmount)
                    };
                }
            }

            return {
                cardType: cardTypeFound,
                percentage: 0,
                customerFee: 0,
                totalAmount: convertToMoneyString(getAmount())
            };
        }
    }

    /**
     * Updates the CCV label depending on the credit card number entered.
     */
    function updateCvvLabel() {
        var input = $(DOM.FIELD.CARD_CCV);
        var label = $(DOM.LABEL.CARD_CCV);
        var isAmexCard = CARDS.AMEX.first.test($(DOM.FIELD.CARD_NUMBER).val());
        var cvvDescription = 'CVV ' + (isAmexCard ? '4 ' + $(DOM.LABEL.DIGITS).text() : '');
        input.attr('placeholder', cvvDescription);
        label.text(cvvDescription);
        $(DOM.FIELD.CARD_CCV).attr('data-rule-exactlength', (isAmexCard ? '4' : '3'));
    }

    /**
     * Updates the warning of extra charges based on the credit card number entered.
     */
    function updateExtraChargesWarning() {
        var currentCreditCard = getCurrentCreditCard();

        if (currentCreditCard === undefined || currentCreditCard.percentage === 0) {
            $(DOM.CONTAINER.EXTRA_CHARGES).addClass(DOM.CSS.HIDDEN);
            return;
        } else if (getAmount() !== '') {
            $(DOM.LABEL.EXTRA_CHARGES).html($(DOM.LABEL.EXTRA_CHARGES_TEXT).text()
                .replace(/%t/g, currentCreditCard.cardType)
                .replace(/%p/g, currentCreditCard.percentage)
                .replace(/%c/g, currentCreditCard.customerFee)
                .replace(/%a/g, currentCreditCard.totalAmount));
            $(DOM.CONTAINER.EXTRA_CHARGES).removeClass(DOM.CSS.HIDDEN);
        }
    }

    /**
     * Called if the user elects to pay via credit card
     */
    function onCreditCardSelected() {
        $(DOM.ACTION.PAYMENT_METHOD_BTN).html($(this).find('a').text() + ' <span class="caret"></span>');
        $(DOM.FIELD.PAYMENT_METHOD).attr("placeholder", $(this).find('a').text());
        $(DOM.FIELD.PAYMENT_TYPE).val($(this).data('type'));

        //$(DOM.CONTAINER.WALLET).hide();
        $(DOM.CONTAINER.CARDLIST).hide();
        $(DOM.CONTAINER.CREDIT_CARD).show();
        
        $(DOM.CONTAINER.PAY).show();
        $('#container-paypal-buttons').hide();
        // TODO: more logic once EFT is implemented.
    }

    /**
     * Called if the user elects to pay via EFT
     */
    function onEftSelected() {
        $(DOM.ACTION.PAYMENT_METHOD_BTN).html($(this).find('a').text() + ' <span class="caret"></span>');
        $(DOM.FIELD.PAYMENT_METHOD).attr("placeholder", $(this).find('a').text());
        $(DOM.FIELD.PAYMENT_TYPE).val($(this).data('type'));

        //$(DOM.CONTAINER.WALLET).hide();
        $(DOM.CONTAINER.CARDLIST).hide();
        $(DOM.CONTAINER.CREDIT_CARD).hide();
        
        $(DOM.CONTAINER.PAY).show();
        $('#container-paypal-buttons').hide();
        // TODO: more logic once EFT is implemented.
    }

    function onPayPalSelected() {
        $(DOM.ACTION.PAYMENT_METHOD_BTN).html($(this).find('a').text() + ' <span class="caret"></span>');
        $(DOM.FIELD.PAYMENT_METHOD).attr("placeholder", $(this).find('a').text());
        $(DOM.FIELD.PAYMENT_TYPE).val($(this).data('type'));

        //$(DOM.CONTAINER.WALLET).hide();
        $(DOM.CONTAINER.CARDLIST).hide();
        $(DOM.CONTAINER.CREDIT_CARD).hide();

        $(DOM.CONTAINER.PAY).hide();
        $('#container-paypal-buttons').show();

        // TODO: more logic once EFT is implemented.
    }
    

    /**
     * Called if the user elects to pay via WALLET
     */
    /*
    function onWalletSelected() {
        $(DOM.ACTION.PAYMENT_METHOD_BTN).html($(this).find('a').text() + ' <span class="caret"></span>');
        $(DOM.FIELD.PAYMENT_METHOD).attr("placeholder", $(this).find('a').text());
        $(DOM.FIELD.PAYMENT_TYPE).val($(this).data('type'));

        $(DOM.CONTAINER.WALLET).show();
        $(DOM.CONTAINER.CREDIT_CARD).hide();

        $(DOM.CONTAINER.PAY).hide();


        // TODO: more logic once WALLET is implemented.
    }
    */
    /*
    function onLoginClicked() {
        showLoader();

        var username = $(DOM.FIELD.USERNAME).val();
        var password = $(DOM.FIELD.PASSWORD).val();

        var url = window.baseurl + "/integration/" + encodeURIComponent(username) + "/" + encodeURIComponent(password);

        $.getJSON(url, function (result) {
            hideLoader();

            if (result.success) {
                onLoginSuccess(result);
            } else {
                onLoginFailed(result);
            }
        }).fail(function () {
            hideLoader();
            showError("Login", "An unknown error has occurred");
        });
    }

    function onLoginSuccess(result) {
        var cardListSelect = $(DOM.FIELD.CARDLIST);
        cardListSelect.empty();

        var option = $('<option/>').val(null).text('- Select a card -');
        cardListSelect.append(option);

        $.each(result.cards, function (index, card) {
            var option = $('<option/>').val(card.id).text(card.alias).attr('data-type', card.type);

            cardListSelect.append(option);
        });

        $(DOM.FIELD.USER_ID).val(result.uid);

        $(DOM.CONTAINER.CARDLIST).show();
        //$(DOM.CONTAINER.WALLET).hide();
        $(DOM.CONTAINER.PAY).show();
    }

    function onLoginFailed(result) {
        //$(DOM.CONTAINER.WALLET).show();
        $(DOM.CONTAINER.CARDLIST).hide();
        showError("Login", result.message);
    }
    */
    /**
     * Transfroms a floating point string into human readable currency.
     * @param {String} value the value to be transformed.
     */
    function convertToMoneyString(value) {
        var length = value.length;
        var pointIndex = value.indexOf('.');
        return ((pointIndex === 0) ? '0' : '') +
            value + ((pointIndex === -1) ? '.00' :
                (length - pointIndex === 1) ? '00' :
                    (length - pointIndex === 2) ? '0' : '');
    }

    /**
     * @returns {String} the amount the user has entered. This can either be the
     * amount or the deposit (depending on which of the 2 is visible).
     */
    function getAmount() {
        var field = $(DOM.FIELD.AMOUNT_TO_PAY).length !== 0 ?
            $(DOM.FIELD.AMOUNT_TO_PAY) : $(DOM.FIELD.AMOUNT_DEPOSIT);
        return $(field).val().trim();
    }

    function showError(title, error) {
        var container = $(DOM.CONTAINER.ERROR_DIALOG);

        container.find('.modal-body').html($('<p/>').text(error));
        container.find('.modal-title').html(title);

        container.modal('show');
    }

    /**
     * Ensures that the terms and condistions are agreed to before submitting the page
     * @param {event} e the form submit event
     */
    function onFormSubmit(e) {
        var paymentMethod = getPaymentType();
        var recaptchaValue = $(DOM.FIELD.PG_RECAPTCH).val();

        console.log('recaptchaValue ' + recaptchaValue);
        // Only handle instant eft payment if terms are not accepted.
        //if (paymentMethod === 'instanteft' && ($(DOM.FIELD.TERMS).length !== 0) && $(DOM.FIELD.TERMS).is(':checked')) {
        if (paymentMethod === 'instanteft') {
            console.log('show eft');

//            console.log($(DOM.CONTAINER.FORM).serialize());
//            jQuery.ajax({
//                'type': 'POST',
//                'url': window.baseurl + "/eft/create",
//                'data': $(DOM.CONTAINER.FORM).serialize(),
//                'success': function (data) {  
//                    sendForm(data.data, data.redirectUrl);
//                }
//            });
//
//
//            e.preventDefault();
        } else if ($('.' + DOM.CSS.ERROR + ':visible').length !== 0) {
            console.log('show errors');
            e.preventDefault();
            $(DOM.CONTAINER.ERRORS_EXIST).modal('show');
        } else if (($(DOM.FIELD.TERMS).length !== 0) && !$(DOM.FIELD.TERMS).is(':checked')) {
            console.log('show terms');
            e.preventDefault();
            $(DOM.CONTAINER.CONFIRM_TERMS).modal('show');
        } else if ($(DOM.FIELD.TMT_V2).val() === 'tmtv2') {
            console.log('v2payment');

        } else if ($(DOM.FIELD.CARD_STORAGE).val() === 'card-storage' && !$(DOM.CONTAINER.CONFIRM_PAYMENT).is(':visible')) {
            console.log('card dstoage');
            e.preventDefault();
            $(DOM.CONTAINER.CONFIRM_PAYMENT).modal('show');
        } else if (paymentMethod === 'paypal') {
            console.log('show paypal');
        } else if (!$(DOM.CONTAINER.CONFIRM_PAYMENT).is(':visible') && (recaptchaValue == 'empty' || recaptchaValue == 'pg-recaptcha-token')) {
            console.log('Show confirm');
            
            // if (!!currentCreditCard || currentCreditCard == null) {
            //     console.log('Continue');
            //     return;
            // }
            var currentCreditCard = getCurrentCreditCard();
            if (!currentCreditCard) {
                return;
            }
            e.preventDefault();
            
            var amount = currentCreditCard.totalAmount;
            var confirmPaymentText = $(DOM.LABEL.CONFIRM_PAYMENT_TEXT)
                .text().replace(/%d/g, amount);
            var currency = ($('#pageInfo_currency').text().length>0) ? $('#pageInfo_currency').text():'ZAR';
            confirmPaymentText = confirmPaymentText.replace(/%s/g, currency);
            var chargeAmount = $(DOM.FIELD.AMOUNT_TO_PAY_CHARGE).val();
            if (chargeAmount != '' && chargeAmount  != undefined && $('#pageInfo_currency_charge').text() != undefined && $('#pageInfo_currency_charge').text() != '') {
                currency = $('#pageInfo_currency_charge').text();
                confirmPaymentText = $(DOM.LABEL.CONFIRM_PAYMENT_TEXT).text().replace(/%d/g, chargeAmount);
                confirmPaymentText = confirmPaymentText.replace(/%s/g, currency);
            }

            $(DOM.LABEL.CONFIRM_PAYMENT).text(confirmPaymentText);
            $(DOM.CONTAINER.CONFIRM_PAYMENT).modal('show');
        } else if ($(DOM.FIELD.PG_RECAPTCH).val() === 'empty') {
            console.log('Can continue. Now let\'s go payment page');
            
            
			e.preventDefault();
			grecaptcha.enterprise.ready(async () => {
				const token = await grecaptcha.enterprise.execute('6LeaSiIpAAAAAPatses1RV2yBN__09VsDPeBxy88', {action: 'LOGIN'});
                $(DOM.FIELD.PG_RECAPTCH).val(token);
                $(DOM.CONTAINER.FORM).submit();
			});
        } else {
            console.log('Final');
        }
    }

    function showLoader() {
        $('.fader, .loader').show()
    }

    function hideLoader() {
        $('.fader, .loader').hide()
    }

    function sendForm(data, url) {
        var form = $('<form/>');
        form.attr('method', 'post');
        form.attr('action', url);
        form.css('display', 'none');

        for (i in data) {
            var input = $('<input/>');
            input.attr('type', 'hidden');
            input.attr('name', i);
            input.attr('value', data[i]);

            form.append(input);
        }

        form.appendTo('body');
        form.submit();
    }

    $('#threeds-form').submit();

    setTimeout(function () {
        if (document.getElementById('threedsv2X-form')) {
            document.getElementById('threedsv2X-form').submit();
        }
    }, 3000);

    

    $('#threeds-frame').on('load', function () {
        $(this).css('display', 'block');
        $('#threeds-msg').css('display', 'none');
    });
})(jQuery);
